/**
 * Auth Feature Routes — Donor Portal
 */
import type { RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores';

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/LoginView.vue'),
    meta: {
      requiresAuth: false,
      title: 'Sign In',
    },
  },
  // Shown instead of /login when a session is already active on this
  // device (e.g. an invite email link opened on a shared device) —
  // see authGuard's redirect in router/guards.ts.
  {
    path: '/active-session',
    name: 'active-session',
    component: () => import('./views/ActiveSessionView.vue'),
    meta: {
      requiresAuth: false,
      title: 'Someone else is signed in',
    },
    beforeEnter: () => {
      const authStore = useAuthStore();
      return authStore.isAuthenticated ? undefined : { name: 'login' };
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/ResetPasswordView.vue'),
    meta: {
      title: 'Reset Password',
      requiresAuth: false,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('./views/ForgotPasswordView.vue'),
    meta: {
      title: 'Forgot Password',
      requiresAuth: false,
    },
  },
  {
    path: '/logout',
    name: 'logout',
    redirect: { name: 'login' },
  },
  {
    path: '/mfa-setup',
    name: 'mfa-setup',
    component: () => import('./views/MfaSetupView.vue'),
    meta: {
      title: 'Set Up Two-Factor Authentication',
      requiresAuth: false,
    },
  },
  {
    path: '/mfa',
    name: 'mfa-challenge',
    component: () => import('./views/MfaChallengeView.vue'),
    meta: {
      title: 'Two-Factor Authentication',
      requiresAuth: false,
    },
  },
];
